/**
 * Top-centre round bar: T score, round clock, bombsite markers, CT score.
 */
import { TEAM } from '../../net/protocol.js';
import { el, setNum, setClock, setClass } from './dom.js';

export class RoundBar {
  constructor(parent) {
    const root = el('div', 'cs-round', parent);
    this.root = root;

    this.tScore = el('span', 'cs-score cs-team-t', root, '0');
    const mid = el('div', 'cs-mid', root);
    this.timer = el('span', 'cs-timer', mid, '0:00');
    const sites = el('div', 'cs-sites', mid);
    this.siteA = el('b', 'cs-site', sites, 'A');
    this.siteB = el('b', 'cs-site', sites, 'B');
    this.ctScore = el('span', 'cs-score cs-team-ct', root, '0');

    this._site = '';
  }

  update(s) {
    const t = s?.timeLeft ?? 0;
    setClock(this.timer, t);
    setClass(this.timer, 'hot', t <= 10);

    const sc = s?.score ?? null;
    setNum(this.tScore, sc ? sc[TEAM.T] ?? 0 : 0);
    setNum(this.ctScore, sc ? sc[TEAM.CT] ?? 0 : 0);

    const site = s?.bomb?.site ?? null;
    if (site !== this._site) {
      this._site = site;
      setClass(this.siteA, 'on', site === 'A' || site === 'a');
      setClass(this.siteB, 'on', site === 'B' || site === 'b');
    }
  }
}
